import { Component } from '@angular/core';
import { IntersectionObserverDirective } from '../../../core/directives/animate-on-visible.directive';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-get-started',
  imports: [IntersectionObserverDirective, RouterLink],
  templateUrl: './get-started.html',
  styleUrl: './get-started.scss',
})
export class GetStarted {

}
